import { OrganizationRelationshipType } from "@covertree/new-business-graphql";

export const organizationTypeOption: {
  value: OrganizationRelationshipType;
  label: string;
}[] = [
  {
    label: "Owner",
    value: OrganizationRelationshipType.Owner,
  },
  {
    label: "Trustee",
    value: OrganizationRelationshipType.Trustee,
  },
  {
    label: "Partner",
    value: OrganizationRelationshipType.Partner,
  },
  {
    label: "Officer",
    value: OrganizationRelationshipType.Officer,
  },
  {
    label: "Other",
    value: OrganizationRelationshipType.Other,
  },
];
